import { CardContent, Container, Grid, Typography } from '@material-ui/core';
import React, { FC, useState } from 'react';
import Card from 'src/components/Card';
import Button from 'src/components/Button';
import { createUseStyles } from 'src/theming';
import TicketTable from './components/TicketTable';
import SearchView from './components/SearchView';
import { CreateTicketOptions, TicketSearchCriteria } from 'src/interfaces/api/Ticket';
import CreateTicketDialog from '../../../components/display/components/CustomerNavigation/components/CreateTicketDialog';

const useStyles = createUseStyles({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

interface Props {
  onCreateTicket: (ticketOptions: CreateTicketOptions) => void;
}

const TicketPanorama: FC<Props> = ({ onCreateTicket }) => {
  const [isModalPostTicketOpen, setIsModalPostTicketOpen] = useState(false);
  const classes = useStyles();

  const [searchCriteria, setSearchCriteria] = useState<TicketSearchCriteria>({
    stateId: undefined,
    domainId: undefined,
    priority: undefined,
    criticity: undefined,
    closed: false,
  });

  return (
    <>
      <Container maxWidth='xl'>
        <Grid container justifyContent='center' spacing={3}>
          <Grid item xs={11}>
            <Card>
              <CardContent>
                <div className={classes.header}>
                  <Typography variant='h6' gutterBottom>
                    Panorama des tickets
                  </Typography>

                  <Button variant='outlined' color='primary' onClick={() => setIsModalPostTicketOpen(true)}>
                    + Ticket général
                  </Button>
                </div>

                <SearchView
                  searchCriteria={searchCriteria}
                  onCriteriaChange={(criteria) => setSearchCriteria(criteria)}
                />

                <TicketTable searchCriteria={searchCriteria} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      <CreateTicketDialog
        onValidate={onCreateTicket}
        open={isModalPostTicketOpen}
        onClose={() => setIsModalPostTicketOpen(false)}
        isGlobalTicket
      />
    </>
  );
};

export default TicketPanorama;
